let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bKhbL")).then(() => parcelRequire('fVNWj'));